export default __webpack_public_path__ + "static/media/Expediting_Module_Video.179c87aa.mp4";